import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import Row from './Row'
import Detail from './Detail'
import {DETAIL_SIZE, REFRESH_TIMER} from '../store/graphs/constants.js'
import './GraphBlock.css'
import { getData } from '../store/graphs/actions'
import * as graphSelectors from '../store/graphs/reducer'



class GraphBlock extends Component {

  constructor(props){
    super(props)
    this.state = {
      loadedStations: new Set()
    }
    autoBind(this)
  }

  init(){
    // Only load data for selected stations that haven't been loaded yet
    for (const id of this.props.selectedStations){
      if (this.props.stations[id]) {
        this.props.dispatch(getData(id, this.props.stations[id].name))
        // Mark station as loaded
        this.setState(prevState => ({
          loadedStations: new Set([...prevState.loadedStations, id])
        }))
      }
    }
  }

  initRefresh(){
    // Refresh data for currently selected stations (used by timer)
    for (const id of this.props.selectedStations){
      if (this.props.stations[id]) {
        this.props.dispatch(getData(id, this.props.stations[id].name))
      }
    }
  }

  componentWillMount(){
    // Load data for initially selected stations
    if (this.props.selectedStations.length > 0) {
      this.init()
    }
    // Set up timer to refresh data periodically
    this.timerID = setInterval(this.initRefresh, REFRESH_TIMER)
  }

  componentDidUpdate(prevProps){
    // Only load data when the actual selected stations change (not just array reference)
    const prevStations = prevProps.selectedStations.sort().join(',')
    const currentStations = this.props.selectedStations.sort().join(',')

    if (prevStations !== currentStations) {
      // Find newly selected stations that haven't been loaded
      const newStations = this.props.selectedStations.filter(
        id => !this.state.loadedStations.has(id)
      )

      // Only load data for newly selected stations
      for (const id of newStations) {
        if (this.props.stations[id]) {
          this.props.dispatch(getData(id, this.props.stations[id].name))
          // Mark station as loaded
          this.setState(prevState => ({
            loadedStations: new Set([...prevState.loadedStations, id])
          }))
        }
      }
    }
  }

  componentWillUnmount(){
    clearInterval(this.timerID)
  }


   render(){
      var graphBlock = []
      for (var i=0;i<this.props.selectedStations.length;i++){
        const stationID = this.props.selectedStations[i]
        const rowIndex = i
        const rowID = stationID + '_s1'
        const station = {id: stationID, name: this.props.stations[stationID].name}
        graphBlock.push(<Row key={rowIndex} rowIndex={rowIndex} rowID={rowID} station={station}/>)

      }
      if (this.props.detailLocation[0] !== null){

         graphBlock.splice(this.props.detailLocation[0]+1, 0,
            <Detail key={9999} id={this.props.detailLocation[1]} size={DETAIL_SIZE}/>
            )
      }

      return (<div className='graphBlock'>{graphBlock}</div>)
   }
}


function mapStateToProps(state) {
  const {location} = graphSelectors.getDetail(state)
  const stations = graphSelectors.getStationList(state)
  const selectedStations = graphSelectors.getSelectedStations(state)
  const rowIDs = graphSelectors.getRowIDs(state)
  return {
    detailLocation: location,
    selectedStations: selectedStations,
    stations: stations,
    rowIDs: rowIDs
  }
}


export default connect(mapStateToProps)(GraphBlock)
